// 1. 顧客のwishlistを取得する関数
async function fetchCustomerWishlist() {
  const token = localStorage.getItem('customerAccessToken');
  if (!token) {
    console.error('トークンがありません');
    return;
  }

  const query = `
    query {
      customer(customerAccessToken: "${token}") {
        id
        metafield(namespace: "custom", key: "wishlist") {
          value
        }
      }
    }
  `;

  const response = await fetch('/api/2023-04/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'f7c19a54ea00c254d56cb079bf487ff3'
    },
    body: JSON.stringify({ query })
  });

  const result = await response.json();

  if (result.data.customer && result.data.customer.metafield) {
    const wishlistValue = result.data.customer.metafield.value;
    let wishlist = [];
    if (wishlistValue) {
      wishlist = JSON.parse(wishlistValue);
    }
    console.log('取得したwishlist:', wishlist);
    return wishlist;
  } else {
    console.log('wishlistはまだ何も保存されていません');
    return [];
  }
}

// 顧客のwishlistを保存する関数
async function updateWishlistOnShopify(newWishlist) {
  const token = localStorage.getItem('customerAccessToken');
  if (!token) {
    console.error('トークンがありません');
    return;
  }

  // まずcustomer IDを取得
  const customerData = await fetch('/api/2023-04/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'f7c19a54ea00c254d56cb079bf487ff3'
    },
    body: JSON.stringify({
      query: `
        query {
          customer(customerAccessToken: "${token}") {
            id
          }
        }
      `
    })
  });

  const customerResult = await customerData.json();
  const customerId = customerResult.data?.customer?.id;

  if (!customerId) {
    console.error('顧客IDを取得できませんでした');
    return;
  }

  // wishlistを保存
  const mutation = `
    mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) {
      metafieldsSet(metafields: $metafields) {
        metafields {
          id
          key
          namespace
          value
        }
        userErrors {
          field
          message
        }
      }
    }
  `;

  const variables = {
    metafields: [
      {
        ownerId: customerId,
        namespace: "custom",
        key: "wishlist",
        type: "json",
        value: JSON.stringify(newWishlist)
      }
    ]
  };

  const response = await fetch('/api/2023-04/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'f7c19a54ea00c254d56cb079bf487ff3'
    },
    body: JSON.stringify({ query: mutation, variables })
  });

  const result = await response.json();
  console.log('保存結果:', result);
}

// ハートボタン押したときの処理
document.addEventListener('click', async (e) => {
  if (e.target.closest('.wishlist-button')) {
    const button = e.target.closest('.wishlist-button');
    const handle = button.getAttribute('data-product-handle');

    let wishlist = await fetchCustomerWishlist();

    if (!wishlist) {
      wishlist = [];
    }

    const index = wishlist.indexOf(handle);
    if (index === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(index, 1);
    }

    console.log('更新後のwishlist:', wishlist);

    await updateWishlistOnShopify(wishlist);
  }
});

// ページロード時にハート状態を反映
async function highlightWishlistButtons() {
  const wishlist = await fetchCustomerWishlist();
  if (!wishlist || wishlist.length === 0) {
    console.log('お気に入りリストは空です');
    return;
  }

  document.querySelectorAll('.wishlist-button').forEach(button => {
    const handle = button.getAttribute('data-product-handle');
    if (wishlist.includes(handle)) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}

// ページロード後に発火
document.addEventListener('DOMContentLoaded', () => {
  highlightWishlistButtons();
});
